<template>
<v-container>
    <ContractResolver :global="global" />
    <ContractRequest :global="global" />
</v-container>
</template>
<script>
import ContractRequest from '@/components/ContractRequest.vue';
import ContractResolver from '@/components/ContractResolver.vue';
import ContractManager from '@/components/ContractManager.vue';

export default {
    name: "UserView",
    props: ['global'],
    components: { ContractRequest, ContractResolver, ContractManager },
}
</script>